var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{attrs:{"type":'orders',"row-data":_vm.orders,"loading-message":_vm.loadingMessage,"no-rows-message":_vm.noRowsMessage,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }